"use client";

import GalleryGrid from "./GalleryGrid";
import { useLazyAssets } from "@/components/homepage/useLazyAssets";

export default function GalleryImages() {
  const assets = useLazyAssets("gallery");

  if (assets === null) {
    return (
      <div aria-hidden="true" className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="break-inside-avoid mb-6 aspect-[4/3] animate-pulse rounded-[2rem] bg-gray-100" />
        ))}
      </div>
    );
  }

  return (
    <GalleryGrid
      images={assets.map((asset) => ({
        url: asset.url,
        pathname: asset.key,
        category: asset.label || "Gallery",
        alt: asset.alt,
      }))}
    />
  );
}
